export const DEFAULT_RULES_MESSAGE = {
  error: "A despesa está fora da política",
  warning: "A despesa possui aviso(s)",
  warning: "A despesa possui informação",
};
